"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteWarehousesByWarehouseNoValidation = exports.putWarehousesByWarehouseNoValidation = exports.getWarehousesByWarehouseNoValidation = exports.deleteWarehousesBulkValidation = exports.getAreasValidation = exports.putAreafeesByAreaFeeNoValidation = exports.getAreafeesByAreaFeeNoValidation = exports.deleteAreafeesBulkValidation = exports.putDeliveryTemplateGroupsByGroupNoDisplayOrderValidation = exports.deleteDeliveryTemplateGroupsByGroupNoValidation = exports.postDeliveryTemplateGroupsValidation = exports.putDeliveryTemplateGroupsByGroupNoValidation = exports.getDeliveryTemplateGroupsByGroupNoValidation = exports.getDeliveryTemplatesValidation = void 0;
var utils_1 = require("./utils");
var templateGroupNoErrorCode = 'TEMPLATEGROUPNO_ERROR';
var templateGroupNo = 'templateGroupNo';
function getDeliveryTemplatesValidation(getDeliveryTemplatesRequest) {
    var errorList = [];
    var params = getDeliveryTemplatesRequest.params;
    if (!params.partnerNo) {
        utils_1.addErrorList(errorList, 'partnerNo', 'PARTNERNO_ERROR');
    }
    return errorList;
}
exports.getDeliveryTemplatesValidation = getDeliveryTemplatesValidation;
function getDeliveryTemplateGroupsByGroupNoValidation(getDeliveryTemplateGroupsByGroupNoRequest) {
    var errorList = [];
    var params = getDeliveryTemplateGroupsByGroupNoRequest.params;
    if (!params.templateGroupNo) {
        utils_1.addErrorList(errorList, templateGroupNo, templateGroupNoErrorCode);
    }
    return errorList;
}
exports.getDeliveryTemplateGroupsByGroupNoValidation = getDeliveryTemplateGroupsByGroupNoValidation;
function putDeliveryTemplateGroupsByGroupNoValidation(putDeliveryTemplateGroupsByGroupNoRequest) {
    var errorList = [];
    var params = putDeliveryTemplateGroupsByGroupNoRequest.params;
    var data = putDeliveryTemplateGroupsByGroupNoRequest.data;
    if (!params.templateGroupNo) {
        utils_1.addErrorList(errorList, templateGroupNo, templateGroupNoErrorCode);
    }
    if (!data.name) {
        utils_1.addErrorList(errorList, 'name', 'NAME_ERROR');
    }
    if (!data.modifyTemplates && !data.addTemplates) {
        utils_1.addErrorList(errorList, 'templates', 'TEMPLATES_ERROR');
    }
    return errorList;
}
exports.putDeliveryTemplateGroupsByGroupNoValidation = putDeliveryTemplateGroupsByGroupNoValidation;
function postDeliveryTemplateGroupsValidation(postDeliveryTemplateGroupsRequest) {
    var errorList = [];
    var data = postDeliveryTemplateGroupsRequest.data;
    if (!data.name) {
        utils_1.addErrorList(errorList, 'name', 'NAME_ERROR');
    }
    if (!data.templates) {
        utils_1.addErrorList(errorList, 'templates', 'TEMPLATES_ERROR');
    }
    return errorList;
}
exports.postDeliveryTemplateGroupsValidation = postDeliveryTemplateGroupsValidation;
function deleteDeliveryTemplateGroupsByGroupNoValidation(deleteDeliveryTemplateGroupsByGroupNoRequest) {
    var errorList = [];
    var params = deleteDeliveryTemplateGroupsByGroupNoRequest.params;
    if (!params.templateGroupNo) {
        utils_1.addErrorList(errorList, templateGroupNo, templateGroupNoErrorCode);
    }
    return errorList;
}
exports.deleteDeliveryTemplateGroupsByGroupNoValidation = deleteDeliveryTemplateGroupsByGroupNoValidation;
function putDeliveryTemplateGroupsByGroupNoDisplayOrderValidation(putDeliveryTemplateGroupsByGroupNoDisplayOrderRequest) {
    var errorList = [];
    var params = putDeliveryTemplateGroupsByGroupNoDisplayOrderRequest.params;
    if (!params.templateGroupNo) {
        utils_1.addErrorList(errorList, templateGroupNo, templateGroupNoErrorCode);
    }
    if (!params.direction) {
        utils_1.addErrorList(errorList, 'direction', 'DIRECTION_ERROR');
    }
    return errorList;
}
exports.putDeliveryTemplateGroupsByGroupNoDisplayOrderValidation = putDeliveryTemplateGroupsByGroupNoDisplayOrderValidation;
function deleteAreafeesBulkValidation(deleteAreafeesBulkRequest) {
    var errorList = [];
    var params = deleteAreafeesBulkRequest.params;
    if (!params.areaFeeNos) {
        utils_1.addErrorList(errorList, 'areaFeeNos', 'AREAFEENOS_ERROR');
    }
    return errorList;
}
exports.deleteAreafeesBulkValidation = deleteAreafeesBulkValidation;
function getAreafeesByAreaFeeNoValidation(getAreafeesByAreaFeeNoRequest) {
    var errorList = [];
    var params = getAreafeesByAreaFeeNoRequest.params;
    if (!params.areaFeeNo) {
        utils_1.addErrorList(errorList, 'areaFeeNo', 'AREAFEENO_ERROR');
    }
    return errorList;
}
exports.getAreafeesByAreaFeeNoValidation = getAreafeesByAreaFeeNoValidation;
function putAreafeesByAreaFeeNoValidation(putAreafeesByAreaFeeNoRequest) {
    var errorList = [];
    var params = putAreafeesByAreaFeeNoRequest.params;
    if (!params.areaFeeNo) {
        utils_1.addErrorList(errorList, 'areaFeeNo', 'AREAFEENO_ERROR');
    }
    return errorList;
}
exports.putAreafeesByAreaFeeNoValidation = putAreafeesByAreaFeeNoValidation;
function getAreasValidation(getAreasRequest) {
    var errorList = [];
    var params = getAreasRequest.params;
    if (!params.countryCd) {
        utils_1.addErrorList(errorList, 'countryCd', 'COUNTRYCD_ERROR');
    }
    return errorList;
}
exports.getAreasValidation = getAreasValidation;
function deleteWarehousesBulkValidation(deleteWarehousesBulkRequest) {
    var errorList = [];
    var params = deleteWarehousesBulkRequest.params;
    if (!params.warehouseNos) {
        utils_1.addErrorList(errorList, 'warehouseNos', 'WAREHOUSENOS_ERROR');
    }
    return errorList;
}
exports.deleteWarehousesBulkValidation = deleteWarehousesBulkValidation;
function getWarehousesByWarehouseNoValidation(getWarehousesByWarehouseNoRequest) {
    var errorList = [];
    var params = getWarehousesByWarehouseNoRequest.params;
    if (!params.warehouseNo) {
        utils_1.addErrorList(errorList, 'warehouseNo', 'WAREHOUSENO_ERROR');
    }
    return errorList;
}
exports.getWarehousesByWarehouseNoValidation = getWarehousesByWarehouseNoValidation;
function putWarehousesByWarehouseNoValidation(putWarehousesByWarehouseNoRequest) {
    var errorList = [];
    var params = putWarehousesByWarehouseNoRequest.params;
    if (!params.warehouseNo) {
        utils_1.addErrorList(errorList, 'warehouseNo', 'WAREHOUSENO_ERROR');
    }
    return errorList;
}
exports.putWarehousesByWarehouseNoValidation = putWarehousesByWarehouseNoValidation;
function deleteWarehousesByWarehouseNoValidation(deleteWarehousesByWarehouseNoRequest) {
    var errorList = [];
    var params = deleteWarehousesByWarehouseNoRequest.params;
    if (!params.warehouseNo) {
        utils_1.addErrorList(errorList, 'warehouseNo', 'WAREHOUSENO_ERROR');
    }
    return errorList;
}
exports.deleteWarehousesByWarehouseNoValidation = deleteWarehousesByWarehouseNoValidation;
